import { render, staticRenderFns } from "./RatePlans.vue?vue&type=template&id=b3a589d0&"
import script from "./RatePlans.vue?vue&type=script&lang=js&"
export * from "./RatePlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports